import { useMemo } from "react";
import { useAppSelector } from "../store/hooks";
import { GanttTabBarTab } from "../types/ganttChart";

/**
 * Custom hook to determine if drag and drop is allowed based on the selected GanttChartTab
 * @returns {boolean} isDragAndDropAllowed - Whether drag and drop is permitted for the current tab
 */
const useDragAndDropPermission = () => {
  // Listen to the selectedGanttChartTab from Redux store
  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice,
  );

  // Define which tabs allow drag and drop
  const dragDropAllowedTabs: GanttTabBarTab[] = ["Custom"];

  // Memoize the result to prevent unnecessary re-renders
  const isDragAndDropAllowed = useMemo(() => {
    if (!selectedGanttChartTab) {
      return false; // Default
    }

    return dragDropAllowedTabs.includes(selectedGanttChartTab);
  }, [selectedGanttChartTab]);

  return { isDragAndDropAllowed };
};

export default useDragAndDropPermission;
